// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e4f9d42c2e054ccb","5108":"77d743ad05a3ab73","8435":"185c1843b52acc7c"}[chunkId] + ".css";
};